import * as React from "react"
export const PriorityIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={15.999} {...props}>
    <path
      fill="#fff"
      d="M15.357 6.43 9.449.613A2.135 2.135 0 0 0 6.43.638L.613 6.55a2.135 2.135 0 0 0 .025 3.019l5.913 5.817a2.121 2.121 0 0 0 1.5.613h.018a2.122 2.122 0 0 0 1.5-.638l5.817-5.913a2.135 2.135 0 0 0-.029-3.018ZM7.428 4.38a.572.572 0 0 1 1.143 0v4.571a.572.572 0 0 1-1.143 0Zm.571 7.809a.762.762 0 1 1 .762-.762.762.762 0 0 1-.761.763Z"
    />
  </svg>
)
